module.exports = __webpack_public_path__ + "img/banner-vertical.1625a51e.jpg";